import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $BillingCountriesModuleName } from "./billingCountries.types";

const { isLoading } = generateDefaultSelectors($BillingCountriesModuleName);

const getBillingCountries = (state: IState) =>
    getApiDataState(state, $BillingCountriesModuleName)?.data?.countries || [];

export { getBillingCountries, isLoading };
